export const isHomepagePath = (pathname: string) => pathname === '/';
export const isCreateEventPath = (pathname: string) => pathname === '/e';
